import __vue_component__ from './SelectOption.vue.js';

//
var script = {
  name: 'SelectMenu',
  components: {
    SelectOption: __vue_component__
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [Array, Object],
      default: () => ({})
    },
    currentSuggestionIndex: {
      type: Number,
      default: undefined
    },
    hasSuggestions: {
      type: Boolean,
      default: false
    },
    containsQuery: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    noOptionsMessage: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    }
  },
  computed: {
    selectedId() {
      return !Array.isArray(this.selected) ? this.selected.id : undefined;
    }

  },

  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
      setTimeout(() => {
        this.$emit('update-popper-position');
      }, 0);
    }
  },

  methods: {
    onOptionSelected(option) {
      this.$emit('option-selected', option);
    },

    onMouseOver(index) {
      this.$emit('mouseover', index);
    },

    resetIndex() {
      this.$emit('mouseover', undefined);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/SelectMenu.vue_rollup-plugin-vue=script.js